export default "__VITE_ASSET__DQUVOfe5__"